// extracted by mini-css-extract-plugin
module.exports = {"root":"hero_root__1R-qr","inner":"hero_inner__2NJ62","text":"hero_text__4fQwa","formWrapper":"hero_formWrapper__1SdjY","formTitleWrapper":"hero_formTitleWrapper__wqYXJ"};